import React from 'react'
import PropTypes from 'prop-types'

import { connect } from 'react-redux'

import Input from 'components/Input'

import {
  updateDriver,
  deleteDriver,
} from 'components/DriversForm/actions'


export const NewDriver = (props) => {
  return (
    <div className="DriversForm__DriverRow-row">
      <Input
        label="Nombre(s)"
        name="first_name"
        placeholder="Nombre(s)"
        onChange={props.onUpdate}
        value={props.driver.first_name} />
      <Input
        label="Apellidos"
        name="last_name"
        placeholder="Apellidos"
        onChange={props.onUpdate}
        value={props.driver.last_name} />
      <Input
        label="Correo electrónico"
        name="email"
        placeholder="Correo electrónico"
        onChange={props.onUpdate}
        value={props.driver.email} />
      <div className="button-wrapper">
        <button onClick={props.onDelete} className="delete">
          <i className="material-icons">delete_forever</i>
        </button>
      </div>
    </div>
  )
}

NewDriver.propTypes = {
  driver: PropTypes.object.isRequired,
  uuid: PropTypes.string.isRequired
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    onDelete: () => dispatch(deleteDriver(ownProps.uuid)),
    onUpdate: (evt) => dispatch(updateDriver(ownProps.uuid, evt.target.name, evt.target.value))
  }
}


export default connect(null, mapDispatchToProps)(NewDriver)



// WEBPACK FOOTER //
// ./src/components/DriversForm/DriversList/NewDriver/index.js